<div class="global-loader-overlay" *ngIf="isOverlayHost && (isLoading$ | async)" data-global-loading="true" role="status"
  aria-live="polite" aria-label="Loading">
  <owc-progress-spinner [size]="'xxLarge'" [value]="50"></owc-progress-spinner>
</div>
